<template>
    <div class="filter_box">
        <i class="fa fa-search"></i>
        <input type="text" v-model="localSearchFilter" />
        <span v-if="filterCount">{{ filtered_option_list.length }} results</span>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        emits: ['update:filter-search'],
        computed: {
            localSearchFilter: {
                get() {
                    return this.searchFilter
                },
                set(val) {
                    this.$emit('update:filter-search', val)
                }
            },
        },
        props: {
            searchFilter: {
                default() {
                    return '';
                }
            },
            filterCount: {
                default() {
                    return false;
                }
            }
        }
    }
</script>
